<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<div #fe [class.slds-has-error]="!valid"
     class="slds-form-element"><!-- slds-form-element -->

  <ng-container *ngIf="isReadOnly && (!isNew)">
    <span [title]="title"
          class="slds-form-element__label">{{ ff.label }}</span>
    <div class="slds-form-element__control slds-has-divider_bottom">
      <acc-record-value [column]="ff.dataColumn"
                        [cssClass]="'slds-form-element__static'"
                        [record]="record"></acc-record-value>
    </div>
  </ng-container>


  <ng-container *ngIf="!isReadOnly"
                [ngSwitch]="asString(ff.dataColumn?.dataType)">

    <ng-container *ngSwitchCase="'STRING'">
      <label [attr.for]="id"
             [title]="title"
             class="slds-form-element__label">
        <abbr *ngIf="ff.isRequired()" class="slds-required" title="required">*</abbr>
        {{ ff.label }}
        <small>{{ ff.description }}</small>
      </label>
      <div *ngIf="ff.dataColumn?.controlType !== 'textarea'"
           class="slds-form-element__control" data-type="string">
        <input #inEl (focus)="onFocus()"
               [autocomplete]="asString(ff.dataColumn?.autocomplete)"
               [formControl]="control"
               [id]="id"
               [maxlength]="asNumStr(ff.dataColumn?.length)"
               [minLength]="asNumStr(ff.dataColumn?.lengthMin)"
               [name]="ff.name"
               [readOnly]="isReadOnly"
               [required]="ff.isRequired()"
               [type]="asString(ff.dataColumn?.inputType)"
               class="slds-input"/>
      </div>
      <div *ngIf="ff.dataColumn?.controlType === 'textarea'"
           class="slds-form-element__control" data-type="textarea">
        <textarea #inEl (focus)="onFocus()"
                  [formControl]="control"
                  [id]="id"
                  [maxlength]="asNumStr(ff.dataColumn?.length)"
                  [minLength]="asNumStr(ff.dataColumn?.lengthMin)"
                  [name]="ff.name"
                  [readOnly]="isReadOnly"
                  [required]="ff.isRequired()"
                  class="slds-textarea"
                  spellcheck="true"></textarea>
      </div>
      <div *ngIf="!valid"
           [id]="id + '-error'"
           class="slds-form-element__help">{{ errorMessage }}</div>
    </ng-container>

    <ng-container *ngSwitchCase="'BOOLEAN'">
      <div class="slds-form-element__control" data-type="boolean">
        <span class="slds-checkbox">
          <input #inEl [class.slds-hide]="isHidden"
                 [formControl]="control"
                 [id]="id"
                 [name]="ff.name"
                 type="checkbox"/>
          <label [attr.for]="id"
                 [title]="title"
                 class="slds-checkbox__label">
            <span class="slds-checkbox_faux"></span>
            <span class="slds-form-element__label">{{ ff.label }}</span>
            <small>{{ ff.description }}</small>
          </label>
        </span>
      </div>
      <div *ngIf="!valid"
           class="slds-form-element__help">{{ errorMessage }}</div>
    </ng-container>

    <ng-container *ngSwitchCase="'TIMESTAMP'">
      <label [attr.for]="id"
             [title]="title"
             class="slds-form-element__label">
        <abbr *ngIf="ff.isRequired()" class="slds-required" title="required">*</abbr>
        {{ ff.label }}
        <small>{{ ff.description }}</small>
      </label>
      {{ control.value | dateMs:'dateTime' }}
    </ng-container>

    <ng-container *ngSwitchCase="'DATE'">
      <acc-form-date [ff]="ff"
                     [fm]="fm"
                     [theId]="id"></acc-form-date>
    </ng-container>

    <ng-container *ngSwitchCase="'TIME'">
      <label [attr.for]="id"
             [title]="title"
             class="slds-form-element__label">
        <abbr *ngIf="ff.isRequired()" class="slds-required" title="required">*</abbr>
        {{ ff.label }}
        <small>{{ ff.description }}</small>
      </label>
      {{ control.value | dateMs:'time' }}
    </ng-container>

    <ng-container *ngSwitchCase="'INTEGER'">
      <label [attr.for]="id"
             [title]="title"
             class="slds-form-element__label">
        <abbr *ngIf="ff.isRequired()" class="slds-required" title="required">*</abbr>
        {{ ff.label }}
        <small>{{ ff.description }}</small>
      </label>
      <div class="slds-form-element__control" data-type="email">
        <input #inEl (focus)="onFocus()"
               [formControl]="control"
               [id]="id"
               [name]="ff.name"
               [readOnly]="isReadOnly"
               [required]="ff.isRequired()"
               [type]="asString(ff.dataColumn?.inputType)"
               class="slds-input slds-text-align_right"
               inputmode="numeric"/>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'DECIMAL'">
      <label [attr.for]="id"
             [title]="title"
             class="slds-form-element__label">
        <abbr *ngIf="ff.isRequired()" class="slds-required" title="required">*</abbr>
        {{ ff.label }}
        <small>{{ ff.description }}</small>
      </label>
      <div class="slds-form-element__control" data-type="email">
        <input #inEl (focus)="onFocus()"
               [formControl]="control"
               [id]="id"
               [name]="ff.name"
               [readOnly]="isReadOnly"
               [required]="ff.isRequired()"
               class="slds-input slds-text-align_right"
               inputmode="decimal"
               pattern="[0-9,.+-]*"
               type="text"/>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'HOURS'">
      <acc-form-hours [ff]="ff"
                      [fm]="fm"
                      [hoursOnly]=true
                      [theId]="id"></acc-form-hours>
    </ng-container>

    <ng-container *ngSwitchCase="'MINUTES'">
      <acc-form-clock [ff]="ff"
                      [fm]="fm"
                      [theId]="id">
      </acc-form-clock>
    </ng-container>

    <ng-container *ngSwitchCase="'CLOB'">
      <label [attr.for]="id"
             [title]="title"
             class="slds-form-element__label">
        <abbr *ngIf="ff.isRequired()" class="slds-required" title="required">*</abbr>
        {{ ff.label }}
        <small>{{ ff.description }}</small>
      </label>
      Clob
    </ng-container>

    <ng-container *ngSwitchCase="'PHONE'">
      <label [attr.for]="id"
             [title]="title"
             class="slds-form-element__label">
        <abbr *ngIf="ff.isRequired()" class="slds-required" title="required">*</abbr>
        {{ ff.label }}
        <small>{{ ff.description }}</small>
      </label>
      <div class="slds-form-element__control" data-type="phone">
        <input #inEl (focus)="onFocus()"
               [autocomplete]="asString(ff.dataColumn?.autocomplete)"
               [formControl]="control"
               [id]="id"
               [maxlength]="asNumStr(ff.dataColumn?.length)"
               [minLength]="asNumStr(ff.dataColumn?.lengthMin)"
               [name]="ff.name"
               [readOnly]="isReadOnly"
               [required]="ff.isRequired()"
               [type]="asString(ff.dataColumn?.inputType)"
               inputmode="tel"
               class="slds-input"/>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'URL'">
      <label [attr.for]="id"
             [title]="title"
             class="slds-form-element__label">
        <abbr *ngIf="ff.isRequired()" class="slds-required" title="required">*</abbr>
        {{ ff.label }}
        <small>{{ ff.description }}</small>
      </label>
      <div class="slds-form-element__control" data-type="url">
        <input #inEl (focus)="onFocus()"
               [autocomplete]="asString(ff.dataColumn?.autocomplete)"
               [formControl]="control"
               [id]="id"
               [maxlength]="asNumStr(ff.dataColumn?.length)"
               [minLength]="asNumStr(ff.dataColumn?.lengthMin)"
               [name]="ff.name"
               [readOnly]="isReadOnly"
               [required]="ff.isRequired()"
               [type]="asString(ff.dataColumn?.inputType)"
               inputmode="url"
               class="slds-input"/>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'EMAIL'">
      <label [attr.for]="id"
             [title]="title"
             class="slds-form-element__label">
        <abbr *ngIf="ff.isRequired()" class="slds-required" title="required">*</abbr>
        {{ ff.label }}
        <small>{{ ff.description }}</small>
      </label>
      <div class="slds-form-element__control" data-type="email">
        <input #inEl (focus)="onFocus()"
               [autocomplete]="asString(ff.dataColumn?.autocomplete)"
               [formControl]="control"
               [id]="id"
               [maxlength]="asNumStr(ff.dataColumn?.length)"
               [minLength]="asNumStr(ff.dataColumn?.lengthMin)"
               [name]="ff.name"
               [readOnly]="isReadOnly"
               [required]="ff.isRequired()"
               [type]="asString(ff.dataColumn?.inputType)"
               inputmode="email"
               class="slds-input"/>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'FKID'">
      <acc-fk [ff]="ff"
              [fm]="fm"
              [theId]="id">
      </acc-fk>
    </ng-container>
    <ng-container *ngSwitchCase="'SFID'">
      <acc-fk [ff]="ff"
              [fm]="fm"
              [theId]="id">
      </acc-fk>
    </ng-container>

    <ng-container *ngSwitchCase="'PICK'">
      <label [attr.for]="id"
             [title]="title"
             class="slds-form-element__label">
        <abbr *ngIf="ff.isRequired()" class="slds-required" title="required">*</abbr>
        {{ ff.label }}
        <small>{{ ff.description }}</small>
      </label>
      <div class="slds-form-element__control" data-type="pick">
        <div class="slds-select_container">
          <select #inEl (focus)="onFocus()"
                  [formControl]="control"
                  [id]="id"
                  [name]="ff.name"
                  class="slds-select">
            <option *ngFor="let opt of ff.dataColumn?.pickOptionList"
                    [value]="opt.name">{{ opt.label }}</option>
          </select>
        </div>
      </div>
      <div *ngIf="!valid" class="slds-form-element__help">{{ errorMessage }}</div>
    </ng-container>


    <ng-container *ngSwitchCase="'BLOB'">
      <acc-form-file [label]="ff.label ? ff.label : ff.name"
                     [propertyName]="ff.name"
                     [record]="record"
                     (fileUploaded)="fileUploaded($event)"
                     [theId]="id">
      </acc-form-file>
    </ng-container>


    <ng-container *ngSwitchDefault> <!-- input fallback -->
      <label [attr.for]="id"
             [title]="title"
             class="slds-form-element__label">
        <abbr *ngIf="ff.isRequired()" class="slds-required" title="required">*</abbr>
        {{ ff.label }}
        <small>{{ ff.description }}</small>
      </label>
      <div class="slds-form-element__control" data-type="default">
        <input #inEl (focus)="onFocus()"
               [autocomplete]="asString(ff.dataColumn?.autocomplete)"
               [formControl]="control"
               [id]="id"
               [name]="ff.name"
               [readOnly]="isReadOnly"
               [required]="ff.isRequired()"
               [type]="asString(ff.dataColumn?.inputType)"
               class="slds-input"/>
      </div>
      <div *ngIf="!valid"
           [id]="id + '-error'"
           class="slds-form-element__help">{{ errorMessage }}</div>
    </ng-container>

  </ng-container><!-- rw/switch -->

</div>
